const en = {
  order_number: "Order Number",
  recharge_time: "Recharge Time",
  channel: "Channel",
  refund: "Refund",
  official_website: "Official website",
  status: "Status",
  pending_payment: "Pending Payment",
  paid: "Paid Payment",
  cancel: "Cancel Payment",
  refunded: "Refunded Payment",
  refund_initiated: "Refund Initiated",
  amount_or_password_error: "The amount is illegal or the password is not filled in"
};
const zh_hant = {
  order_number: "訂單編號",
  recharge_time: "訂閱時間",
  channel: "渠道",
  refund: "退款",
  official_website: "官網",
  status: "狀態",
  paid: "已支付",
  pending_payment: "待付款",
  cancel: "取消付款",
  refunded: "已退款",
  refund_initiated: "已發起退款",
  amount_or_password_error: "賬號或者密碼未填寫完整"
};
const zh_cn = {
  order_number: "订单编号",
  recharge_time: "订阅时间",
  channel: "渠道",
  refund: "退款",
  official_website: "官网",
  status: "状态",
  paid: "已支付",
  pending_payment: "待付款",
  cancel: "取消付款",
  refunded: "已退款",
  refund_initiated: "已发起退款",
  amount_or_password_error: "账号或者密码未填写完整"
};
const es = {
  order_number: "Número de orden",
  recharge_time: "Tiempo de suscripción",
  channel: "Canal",
  refund: "Reembolso",
  official_website: "Sitio web oficial",
  status: "Estado",
  paid: "Pagado",
  pending_payment: "Pago pendiente",
  cancel: "Cancelar pago",
  refunded: "Pago reembolsado",
  refund_initiated: "Reembolso iniciado",
  amount_or_password_error: "El nombre de cuenta o la contraseña no están ingresados"
};
export default {
  en,
  zh_hant,
  es,
  zh_cn
};
